﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
import { GuiFilterZeitraum } from "../GuiFilterZeitraum";
export class GuiListAktion extends GuiListGeneric {

    constructor() {
        super("Aktion");

        $("#auswertungfilter").removeClass("d-none");

        $("#detailForm select").on("change", () => { this.resetResult(); });
        $("#detailForm input[type=date]").on("blur", () => { this.resetResult(); });
        $("#detailForm button.btn-date-remove").on("click", () => { this.resetResult(); });

        new GuiFilterZeitraum();
    }

    resetResult() {
        $("#txtAktionAnzahl").text("Aktionen (?)");
        $("#btnGotoAktionen").removeClass("btn-success").addClass("btn-secondary").data("anzahl", "");
        $("#btnRefresh").removeClass("btn-secondary").addClass("btn-success");
        this.hideData();
    }

    protected hideData() {
        this.log("hideData");
        $("div.erz-list").hide();
    }

}
